export const kryptomonExtraInfoQuery = (tokenIds: string[]): string => {
  return `{
        orders(where: 
          {tokenId_in: [${tokenIds.toString()}],
          category:kryptomon}, orderBy:createdAt){
          id
          tokenId
          price
          createdAt
          expiresAt
          nftAddress
          status
          owner
          buyer
          paymentToken
          nft {
            contractAddress
          }
          updatedAt
        }
          kryptomons(where: {tokenId_in: [${tokenIds.toString()}]}) {
          tokenId
          timeCanBreed
          owner{
            address
          }
          breedingOrder {
            price
          }
          breedingCount
          breedingsLeft
          activities {
            eventName
            date
            extraData{
              label
              value
            }
          }
        }
          bids(where: {tokenId_in: [${tokenIds.toString()}], expiresAt_gt: "${Date.now()}"}){
            tokenId
            bidder
            price
            status
            expiresAt
            createdAt
            id
            paymentToken
            nftAddress
            blockchainId
            updatedAt
            seller
          }
      }
    `
}

/* following output must have same interface of previous query to avoid to create another interface
its used in notification service */
export const kryptomonsAcceptedBidsQuery = (ownerAddress: string): string => {
  let oneMonthAgoSecond: number = Math.round(Date.now() / 1000 - 30 * 24 * 60 * 60);
  return `{
      bids(where: {bidder: "${ownerAddress}", status: sold, updatedAt_gt: "${oneMonthAgoSecond}"}) {
        tokenId
        bidder
        price
        status
        expiresAt
        createdAt
        id
        paymentToken
        nftAddress
        blockchainId
        updatedAt
        seller
      }
    }`;
}

export const kryptomonsOpenedBidsQuery = (ownerAddress: string): string => {
  return `{
    bids(where: {seller: "${ownerAddress}", status: open, expiresAt_gt: "${Date.now()}"}) {
      tokenId
      bidder
      price
      status
      expiresAt
      createdAt
      id
      paymentToken
      nftAddress
      blockchainId
      updatedAt
      seller
    }
  }`;
}

export const kryptomonsSoldQuery = (ownerAddress: string): string => {
  let oneMonthAgoSecond: number = Math.round(Date.now() / 1000 - 30 * 24 * 60 * 60);
  return `{
    orders(where: {owner:"${ownerAddress}", status: sold, category: kryptomon, updatedAt_gt: "${oneMonthAgoSecond}"}, orderBy: createdAt) {
      id
      tokenId
      price
      createdAt
      expiresAt
      nftAddress
      status
      owner
      buyer
      paymentToken
      nft {
        contractAddress
      }
      updatedAt
    }
  }`;
}


